import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Image } from "@project-stories/elements/Image/Image";

import "./Visual.scss";

export const Visual = ({ settings, blocks }) => {
  let isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const gridCols = isMobile ? (settings.section.grid_cols_mobile || 2) : (settings.section.grid_cols || 4);
  const gap = isMobile ? settings.section.gap_mobile : settings.section.gap;
  
  return (
    <div className={`overflow-x-auto no-scrollbar`}>
      <div className={`grid w-full gap-[${gap}px] `}
        style={{
          ...(isMobile ? {
              gridAutoFlow: 'column',
              gridAutoColumns: 'minmax(252px, 1fr)',
            } : {
              gridTemplateColumns: `repeat(${gridCols}, minmax(0, 1fr))`,
            }
          )
        }}
      >
        {blocks.map((block, index) => {
          const colSpan = isMobile
            ? block.settings?.col_span_mobile || 1
            : block.settings?.col_span || 1;
          const padding = isMobile ?
              `pt-[${block.settings.padding_top_mobile}px]
              pb-[${block.settings.padding_bottom_mobile}px]
              pl-[${block.settings.padding_left_mobile}px]
              pr-[${block.settings.padding_right_mobile}px]` 
            : `pt-[${block.settings.padding_top_desktop}px]
              pb-[${block.settings.padding_bottom_desktop}px]
              pl-[${block.settings.padding_left_desktop}px]
              pr-[${block.settings.padding_right_desktop}px]`;
          
          return (
            <div
              key={block.id || index}
              className={`gradient-border flex flex-col rounded border bg-[#FBF8F4] text-[#1C1C1F] ${padding}`}
              style={{
                gridColumn: `span ${colSpan} / span ${colSpan}`,
              }}
            >
              {block.settings?.image && (
                <Image
                  imageUrl={block.settings.image}
                  alt={block.settings.title || ""}
                  classes={`w-12 h-12 ${block.settings?.col_span > 1 ? "mb-6" : "mb-4"}`}
                />
              )}
              {block.settings?.text && (
                <div className={`capitalize ${isMobile ? block.settings.text_style_mobile : block.settings.text_style}`}>
                  {block.settings.text}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Visual;